var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "main"
  }, [_c('a-form', {
    ref: "formLogin",
    staticClass: "user-layout-login",
    attrs: {
      "form": _vm.form,
      "id": "formLogin"
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['username', {
        initialValue: '',
        rules: _vm.validatorRules.username.rules
      }],
      expression: "[\n              'username',\n              { initialValue: '', rules: validatorRules.username.rules },\n            ]"
    }],
    attrs: {
      "size": "large",
      "type": "text",
      "placeholder": "请输入身份证号/手机号"
    }
  }, [_c('a-icon', {
    style: {
      color: 'rgba(0,0,0,.25)'
    },
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['password', {
        initialValue: '',
        rules: _vm.validatorRules.password.rules
      }],
      expression: "[\n              'password',\n              {\n                initialValue: '',\n                rules: validatorRules.password.rules,\n              },\n            ]"
    }],
    attrs: {
      "size": "large",
      "type": "password",
      "autocomplete": "false",
      "placeholder": "密码"
    }
  }, [_c('a-icon', {
    style: {
      color: 'rgba(0,0,0,.25)'
    },
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('a-col', {
    attrs: {
      "span": 16
    }
  }, [_c('a-form-item', [_c('a-input', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['inputCode', _vm.validatorRules.inputCode],
      expression: "['inputCode', validatorRules.inputCode]"
    }],
    attrs: {
      "size": "large",
      "type": "text",
      "autocomplete": "false",
      "placeholder": "请输入验证码"
    },
    on: {
      "change": _vm.inputCodeChange
    }
  }, [_c('a-icon', {
    style: {
      color: 'rgba(0,0,0,.25)'
    },
    attrs: {
      "slot": "prefix",
      "type": "smile"
    },
    slot: "prefix"
  })], 1)], 1)], 1), _c('a-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 8
    }
  }, [_vm.requestCodeSuccess ? _c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": _vm.randCodeImage
    },
    on: {
      "click": _vm.handleChangeCheckCode
    }
  }) : _c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": require("@/assets/checkcode.png")
    },
    on: {
      "click": _vm.handleChangeCheckCode
    }
  })])], 1), _c('a-form-item', [_c('a-checkbox', {
    directives: [{
      name: "decorator",
      rawName: "v-decorator",
      value: ['rememberMe', {
        initialValue: true,
        valuePropName: 'checked'
      }],
      expression: "[\n          'rememberMe',\n          { initialValue: true, valuePropName: 'checked' },\n        ]"
    }]
  }, [_vm._v("自动登录")]), _c('a', {
    staticClass: "forge-password",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.handleClickForgetPwd
    }
  }, [_vm._v("\n        忘记密码\n      ")]), _c('a', {
    staticClass: "forge-password",
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v("\n        注册账户\n      ")])], 1), _c('a-form-item', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_c('a-button', {
    staticClass: "login-button",
    attrs: {
      "size": "large",
      "type": "primary",
      "htmlType": "submit",
      "loading": _vm.loginBtn,
      "readOnly": _vm.loginBtn
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v("确定\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };